export default function(location: Location) {
  return /resource/.test(location.pathname);
}
